import React, { useEffect, useState } from "react";
import { signUp } from "../redux/actions/auth.js";
import { useDispatch } from "react-redux";
import Email from "@material-ui/icons/Email";
import Phone from "@material-ui/icons/Phone";
import User from "@material-ui/icons/Person";
import Orgnz from "@material-ui/icons/Group";
import CardMembership from "@material-ui/icons/CardMembership";
import Password from "@material-ui/icons/Lock";
import CloseIcon from '@material-ui/icons/Close';
import Location from "@material-ui/icons/AddLocation";
import ConfirmPassword from "@material-ui/icons/Error";
import logo from "../assets/nabeel4.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { NavLink } from "react-router-dom";

const SignUp = () => {
  const validationSchema = Yup.object().shape({
    fullName: Yup.string().required("حقل الاسم مطلوب"),
    email: Yup.string().email("الايميل غير صالح").required("حقل الايميل مطلوب"),
    password: Yup.string()
      .min(6, "يجب ان يكون الباسورد 6 احرف على الاقل")
      .required("حقل الباسورد مطلوب"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "يجب التطابق مع الباسورد")
      .required("حقل تاكيد الباسورد مطلوب"),
    phoneNumber: Yup.string()
      .length(10, "رقم الهاتف يجب ان يكون 10 ارقام بدون صفر البداية")
      .required("حقل رقم الهاتف مطلوب"),
    province: Yup.string().required("حقل المحافظة مطلوب"),
    city: Yup.string().required("حقل المدينة مطلوب"),
    hasOrganization: Yup.bool().required("يجب الاختيار"),
    organizationName: Yup.string().when("hasOrganization", {
      is: true,
      then: Yup.string().required("حقل اسم المنظمة مطلوب"),
      otherwise: Yup.string().notRequired(),
    }),
    organizationId: Yup.string().when("hasOrganization", {
      is: true,
      then: Yup.string().required("حقل رقم التعريف مطلوب"),
      otherwise: Yup.string().notRequired(),
    }),
    acceptTerms: Yup.bool().oneOf([true], "يجب قبول او رفض الاحكام والخدمة"),
  });
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    values,
    errors,
  } = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
      phoneNumber: "",
      province: "",
      city: "",
      hasOrganization: false,
      organizationName: "",
      organizationId: 0,
      acceptTerms: false,
    },
    validationSchema,
    onSubmit(values) {
      dispatch(signUp(values));

    },
  });

  const prefixCode = ["77", "78", "79", "75"];

  const dispatch = useDispatch();

  let [isWithOrganization, setIsWithOrganization] = useState(false);

  let [selectedGove, setSelectedGove] = useState([]);

  let [isSmallScreen, setIsSmallScreen] = useState(
    window.matchMedia("(max-width: 768px)").matches
  );
  let [cityArr, setCityArr] = useState();
  let [OpenTermsModel, setOpenTermsModel] = useState(false);

  useEffect(() => {
    const handler = (e) => setIsSmallScreen(e.matches);
    window.matchMedia("(max-width: 768px)").addListener(handler);

    fetch("https://iq-cities.herokuapp.com/city")
      .then((response) => response.json())
      .then((json) => {
        let goves = ["المحافظة", ...json];
        setSelectedGove(goves);
      });
  }, []);
  const createInput = (name, inputValues, otherInputAtt) => (
    <input
      name={name}
      type="text"
      onChange={handleChange}
      onBlur={handleBlur}
      {...otherInputAtt}
      values={inputValues ? inputValues : ""}
      className="rounded-full  px-4 border w-full border-gray-500 justify-end h-8 text-base focus:outline-none  text-black text-right"
    />
  );
  const showTermsModel = () => {
    setOpenTermsModel(!OpenTermsModel);
  };
  return (
    <div className=" my-4 lg:p-4 lg-m-0 signup-bg text-gray-700 mb-10">
      <div className="lg:w-full xl:w-4/5 mx-auto bg-white lg:bg-transparent">
        <div
          className="lg:z-40  lg:shadow-lg bg-white
       lg:mt-24 mx-auto md:px-8 px-4 sm:w-3/4 md:w-4/5 mb-10 mt-10 lg:border lg:border-gray-500 
       lg:rounded-lg lg:bg-gray-100 lg:px-10 xl:px-16 lg:py-12 lg:clearfix"
        >
          {isSmallScreen ? (
            <>
              <div className="flex flex-col items-center ">
                <NavLink to="/">
                  <img src={logo} alt="logo" className="mb-10" />
                </NavLink>
              </div>
            </>
          ) : null}
          <p className="w-full text-xl lg:mt-6 mb-16 lg:mb-0 text-right font-bold text-gray-700">
            انشئ حسابك
          </p>
          <p className="text-right mb-12  text-gray-700 hidden lg:block">
            هل لديك حساب ؟<span> </span>
            <NavLink to="/sign-in" className="n-blue cursor-pointer">
              سجل دخول
            </NavLink>
          </p>
          <form className="px-2 mt-8" onSubmit={handleSubmit}>
            <div className=" lg:flex  lg:flex-col">
              <div className=" lg:flex lg:flex-row-reverse">
                <div className=" lg:flex mx-4 lg:flex-col lg:justify-end lg:w-1/2">
                  <label
                    className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4 justify-end`}
                  >
                    <div className="flex items-center">
                      الاسم الكامل
                    <User alt="user" className=" ml-2" color="primary" />
                    </div>
                  </label>
                  {createInput("fullName", values.fullName)}
                  <p className="h-3 text-red-400 font-normal">
                    {touched.fullName && errors.fullName
                      ? errors.fullName
                      : null}
                  </p>
                </div>
                <div className=" lg:flex mx-4 lg:flex-col lg:justify-end lg:w-1/2">
                  <label
                    className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4 justify-end`}
                  >
                    <div className="flex items-center">
                      رقم الهاتف
                    <Phone
                        alt="user"
                        className=" ml-2"
                        fontSize="small"
                        color="primary"
                      />
                    </div>

                  </label>
                  {createInput("phoneNumber", values.phoneNumber, {
                    list: "data",
                  })}
                  <datalist id="data">
                    {prefixCode.map((item, key) => (
                      <option key={key} value={item}>
                        {item}
                      </option>
                    ))}
                  </datalist>
                  <p className="h-3 text-red-400 font-normal">
                    {touched.phoneNumber && errors.phoneNumber
                      ? errors.phoneNumber
                      : null}
                  </p>
                </div>
              </div>
              <div className=" lg:flex mt-2 lg:flex-row-reverse">
                <div className=" lg:flex mx-4 lg:flex-col lg:justify-end lg:w-1/2">
                  <label
                    className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4 justify-end`}
                  >
                    <div className="flex items-center">
                      ايميل
                    <Email
                        alt="user"
                        className="ml-2"
                        fontSize="small"
                        color="primary"
                      />
                    </div>

                  </label>
                  {createInput("email", values.email)}
                  <p className="h-3 text-red-400 font-normal">
                    {touched.email && errors.email ? errors.email : null}
                  </p>
                </div>
                {isSmallScreen ? (
                  <div className=" lg:flex mx-4 lg:flex-col lg:justify-end lg:w-1/2">
                    <label
                      className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4 justify-end`}
                    >
                      <div className="flex items-center">
                        كلمة السر
                      <Password
                          alt="user"
                          className="ml-2"
                          style={{ fontSize: 22 }}
                          color="primary"
                        />
                      </div>

                    </label>
                    {createInput("password", values.password)}
                    <p className="h-3 text-red-400 font-normal">
                      {touched.password && errors.password
                        ? errors.password
                        : null}
                    </p>
                  </div>
                ) : null}
                {isSmallScreen ? (
                  <div className=" lg:flex mx-4 lg:flex-col lg:justify-end lg:w-1/2">
                    <label
                      className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4 justify-end`}
                    >
                      <div className="flex items-center">

                        تأكيد كلمة السر
                      <ConfirmPassword
                          alt="user"
                          className="ml-2"
                          fontSize="small"
                          color="primary"
                        />
                      </div>

                    </label>
                    {createInput("confirmPassword", values.confirmPassword)}
                    <p className="h-3 text-red-400 font-normal">
                      {touched.confirmPassword && errors.confirmPassword
                        ? errors.confirmPassword
                        : null}
                    </p>
                  </div>
                ) : null}
                <div className=" lg:flex mx-4 lg:flex-col lg:justify-end lg:w-1/2">
                  <label
                    className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4 justify-end`}
                  >
                    <div className="flex items-center">
                      العنوان
                    <Location alt="user" className="ml-2" color="primary" />
                    </div>

                  </label>
                  <div className=" lg:flex lg:flex-row-reverse">
                    <div className="display inline w-1/7">
                      <select
                        name="province"
                        type="text"
                        placeholder="المحافظة"
                        onChange={(e) => {
                          let arr = selectedGove.filter(
                            (item) => item.name === e.target.value
                          );

                          let govArr = ["المنطقة", ...arr[0].towns];
                          setCityArr(govArr);
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        values={values.province}
                        value={values.province || selectedGove[0]}
                        className="rounded-full px-4 border border-gray-500 w-full h-8 mb-2 lg:mb-0
                    text-base flex justify-end items-center focus:outline-none text-left"
                      >
                        {selectedGove
                          ? selectedGove.map((item, index) =>
                            index === 0 ? (
                              <option
                                key={index + "item"}
                                disabled
                                value={item}
                                className="text-right"
                              >
                                {item}
                              </option>
                            ) : (
                              <option
                                key={item.id}
                                value={item.name}
                                className="text-right"
                              >
                                {item.name}
                              </option>
                            )
                          )
                          : null}
                      </select>
                    </div>
                    <div className="display inline lg:mr-4 w-1/7">
                      <select
                        name="city"
                        type="text"
                        placeholder="المنطقة"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        values={values.city}
                        value={values.city || (cityArr ? cityArr[0] : "")}
                        className="rounded-full px-4 border border-gray-500 w-full h-8 mb-2 lg:mb-0
                     text-base text-base flex justify-end items-center  focus:outline-none "
                      >
                        {cityArr
                          ? cityArr.map((item, index) =>
                            index === 0 ? (
                              <option
                                key={index}
                                disabled
                                value={item}
                                className="text-right"
                              >
                                {item}
                              </option>
                            ) : (
                              <option
                                key={index}
                                value={item}
                                className="text-right"
                              >
                                {item}
                              </option>
                            )
                          )
                          : null}
                      </select>
                    </div>
                  </div>
                  <p className="h-3 text-red-400 font-normal text-left">
                    {touched.province && errors.province
                      ? errors.province
                      : touched.city && errors.city
                        ? errors.city
                        : null}
                  </p>
                </div>
              </div>

              <div className=" lg:flex mt-4 lg:mt-0 lg:flex-row-reverse">
                {!isSmallScreen ? (
                  <div className=" lg:flex mx-4 lg:flex-col lg:justify-end lg:w-1/2">
                    <label
                      className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4 justify-end`}
                    >
                      <div className="flex items-center">
                        كلمة السر
                      <Password
                          alt="user"
                          className=" ml-2 bg-blue"
                          color="primary"
                          fontSize="default"
                        />
                      </div>

                    </label>
                    {createInput("password", values.password)}
                    <p className="h-3 text-red-400 font-normal">
                      {touched.password && errors.password
                        ? errors.password
                        : null}
                    </p>
                  </div>
                ) : null}
                <div className=" lg:flex mx-4 pt-2 lg:flex-col lg:justify-end text-center lg:w-1/2">
                  <label
                    className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4  ${isSmallScreen ? "justify-center" : "justify-end"
                      }`}
                  >
                    هل يوجد منظمة تنتمي اليها ؟
                  </label>
                  <div className="mb-3 lg:flex lg:flex-row-reverse text-center lg:text-right w-full">
                    <label className="text-base mx-2 rounded-full  inline inline-block">

                      نعم
                      <input
                        name="hasOrganization"
                        type="radio"
                        onChange={() => {
                          values.hasOrganization = true;
                        }}
                        onBlur={handleBlur}
                        onClick={() => setIsWithOrganization(false)}
                        className="mr-4 ml-2 focus:outline-none text-black text-center lg:text-right"
                      />


                    </label>
                    <label className="text-base  rounded-full md:mt-0 mx-2  inline-block">

                      كلا
                      <input
                        name="hasOrganization"
                        type="radio"
                        onChange={() => {
                          values.hasOrganization = false;
                        }}
                        onBlur={handleBlur}
                        onClick={() => setIsWithOrganization(true)}
                        className="mr-2 ml-2 focus:outline-none text-black text-right"
                      />


                    </label>
                  </div>
                </div>
              </div>

              <div className=" lg:flex mt-2 lg:flex-row-reverse">
                {!isSmallScreen ? (
                  <div className=" lg:flex mx-4 lg:flex-col lg:justify-end lg:w-1/2">
                    <label
                      className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4 justify-end`}
                    >
                      <div className="flex items-center">
                        تأكيد كلمة السر
                      <ConfirmPassword
                          alt="user"
                          className="ml-2"
                          fontSize="small"
                          color="primary"
                        />
                      </div>

                    </label>
                    {createInput("confirmPassword", values.confirmPassword)}
                    <p className="h-3 text-red-400 font-normal">
                      {touched.confirmPassword && errors.confirmPassword
                        ? errors.confirmPassword
                        : null}
                    </p>
                  </div>
                ) : null}
                <div className=" lg:flex mx-4 lg:flex-col lg:justify-end lg:w-1/2">
                  <div className=" lg:flex lg:flex-row-reverse">
                    <div className="mt-8 lg:mt-0 lg:flex mx-1 lg:flex-col lg:justify-end lg:w-1/2">
                      <label
                        className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4 justify-end`}
                      >
                        <div className="flex items-center">
                          اسم المنظمة
                        <Orgnz
                            alt="user"
                            className="ml-2"
                            color="primary"
                          />
                        </div>

                      </label>
                      {createInput(
                        "organizationName",
                        values.organizationName,
                        {
                          disabled: isWithOrganization,
                        }
                      )}
                    </div>
                    <div className=" lg:flex mx-1 lg:flex-col lg:justify-end lg:w-1/2">
                      <label
                        className={`text-base pb-1 flex items-center mb-1 mr-1 mt-4 justify-end`}
                      >
                        <div className="flex items-center">
                          رقم المعرف
                        <CardMembership
                            alt="user"
                            className="ml-2"
                            color="primary"
                          />
                        </div>

                      </label>

                      {createInput("organizationId", values.organizationId, {
                        disabled: isWithOrganization,
                      })}
                    </div>
                  </div>
                  <p className="h-3 text-red-400 font-normal text-left">
                    {(touched.organizationName &&
                      errors.organizationName &&
                      values.hasOrganization) ||
                      (touched.organizationId &&
                        errors.organizationId &&
                        values.hasOrganization)
                      ? "حقلي رقم المعرف واسم المنظمة مطلوبة"
                      : null}
                  </p>
                </div>
              </div>

              <div className=" flex flex-col mt-12 ">
                <div className="flex justify-center flex-row">
                  <p
                    className="n-blue cursor-pointer -mt-1"
                    onClick={showTermsModel}
                  >
                    الشروط والخدمة
                  </p>
                  <input
                    name="acceptTerms"
                    type="checkbox"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="display inline border border-gray-500 bg-white ml-2 focus:outline-none text-black text-right"
                  />
                </div>

                <p className="h-3 text-red-400 font-normal text-center">
                  {touched.acceptTerms && errors.acceptTerms
                    ? errors.acceptTerms
                    : null}
                </p>
              </div>
              <div className="flex justify-center mt-8 mb-8">
                <button
                  id="sign-in-button"
                  type="submit"
                  className="rounded-lg mb-6 py-2 px-3 text-white focus:outline-none blue-bg"
                >
                  انشئ حساب
                </button>
              </div>
            </div>
            <p className="text-center mt-4 mb-8 text-gray-700  lg:hidden">
              هل لديك حساب ؟<span> </span>
              <NavLink to="/sign-in" className="n-blue cursor-pointer">
                سجل دخول
              </NavLink>
            </p>
          </form>
        </div>
      </div>
      <div
        className={`w-full h-full bg-model fixed top-0 left-0 justify-center items-center z-40 ${OpenTermsModel ? "flex" : "hidden"
          }`}
      >
        <div className="  md:w-2/4 md:h-75 model-res bg-white md:rounded-lg p-4 md:relative">
          <div className=" flex justify-end model-p">
            <button onClick={showTermsModel}>
              <CloseIcon alt="exsit" style={{ color: "black" }} />
            </button>
          </div>
          <div>
            <p className="text-center text-xl py-2">شروط الخدمه والاحكام</p>
          </div>
          <div className="flex justify-center pb-4">
            <div
              id="fake_textarea"
              className=" terms-height overflow-y-scroll border-2 rounded-lg focus:outline-none text-black text-right text-sm p-3  w-24rem"
            >
              اولاً: إشتراك المستخدمين
              <br /> يتوجب على المستخدم التسجيل في موقع نبيل قبل التمتع بخصائص
              المستخدمين، وذلك عن طريق تزويد الموقع بالمعلومات الشخصية. ولا يقبل
              الموقع اي طريقة اخرى <br />
              للإشتراك. ثانياً: سجل النشاطات يتيح موقع نبيل إستخدام سجل النشاطات
              الخاص لكل مستخدم بعد الاشتراك، حيث يتمكن المستخدم من اضافة
              البطاقات المختارة لحسابه الخاص اضافةً الى تصفح المعلومات الاضافية
              للبطاقات الخاصة بالمحتاجين المتواجدة في الواجهة الرئيسية. ثالثاً:
              مسؤولية توصيل الاحتياجات يتحمل المستخدم المتطوع لتلبية الاحتياج
              المختار وبعد اضافته لسجل النشاطات، كافة التبعات الاخلاقية
              والقانونية لغرض توصيل الاحتياجات للمحتاجين لها. على ان يؤكد اتمام
              عملية المساعدة عن طريق سجل النشاطات او حذف البطاقة نهائيا من
              السجل. رابعاً: سرية وخصوصية المستخدم يتعهد موقع نبيل بمصداقيته
              بشأن معلومات المستخدمين (الإسم، البريد الاكتروني، رقم الهاتف،
              المحافظة و اسم ورقم المنظمة)، وان هذه المعلومات لن يساء استخدامها
              ولن يتم بيعها او عرضها لأي جهة اخرى. خامساً: إنهاء حساب المستخدم
              يحق لموقع نبيل إنهاء حساب المستخدم بدون إشعار مسبق، واللجوء الى
              القضاء (إن توجب الأمر) في الحالات التالية: ادخال معلومات خاطئة او
              مظللة من قبل المستخدم اثناء عملية التسجيل سوء استخدام الخدمة من
              قبل المستخدم اكتشاف انشطة قرصنة او فعاليات غير طبيعية مشاركة
              المستخدم الخارجة عن السياقات على صفحات التواصل الاجتماعي الخاصة
              بموقع نبيل. سادساً: علاقة المستخدم بالموقع يعمل موقع نبيل باتقان
              للحفاظ على علاقة مهنية وحضارية عالية مع المستخدمين كافة من خلال
              الالتزام بسياسة الاستخدام والخصوصية. يتمنى موقع نبيل التزام
              المستخدمين بهذه السياسات واخلاقيات العمل ايضاً. علماً ان هذه
              السياسات تنطبق ايضا على مشاركات المستخدمين على مواقع التواصل
              الاجتماعي.  سياسة الخصوصية أولاً: تجميع بيانات المستخدمين يقوم
              موقع نبيل بفرض عملية الإشتراك أو التسجيل على المستخدم لغرض تقديم
              الخدمات بالصورة الصحيحة و لضمان الدقة في عمل الخدمة. وخلال عملية
              التسجيل، يقوم موقع نبيل بسؤال المستخدمين عن المعلومات التالية:
              الإسم البريد الالكتروني رقم الموبايل المحافظة اسم ورقم المنظمة
              ثانياً: الغرض من البيانات يحتاج موقع نبيل بيانات المستخدم لأجل:
              إنشاء حساب خاص لكل مستخدم يفصل نشاطه عن باقي المستخدمين تخصيص سجل
              نشاطات لكل مستخدم يفصل اختياراته ومسؤولياته عن باقي اختيارات
              المستخدمين عرض الاحتياجات تبعاً لموقع المستخدم اولاً ثالثاً:
              إستخدام ال(كوكيز) بعكس الكثير من المواقع الألكترونية، خدمة نبيل لا
              تستخدم تقنية ال(كوكيز) إلا لخزن معلومات التسجيل و تسهيل عملية دخول
              المستخدم الى حسابه الخاص على منصة موقع نبيل.
            </div>
          </div>
          <div className="flex justify-center pb-2">
            <button
              onClick={showTermsModel}
              className="blue-bg border text-white rounded-lg p-2 w-40 focus:outline-none"
            >
              تم
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SignUp;
